import { ConversationMessage, ConversationSendMessage } from '@quromedical/communication';
import { ConversationSendTemplateMessage } from '@quromedical/communication/server';
import { trpc } from 'trpc';

export class CommunicationApi {
  public sendMessage = async (message: ConversationSendMessage): Promise<ConversationMessage> => {
    return await trpc.client.communication.conversation.sendMessage.mutate(message);
  };

  public sendTemplateMessage = async (
    templateMessage: ConversationSendTemplateMessage
  ): Promise<ConversationMessage> => {
    return await trpc.client.communication.conversation.sendTemplateMessage.mutate(templateMessage);
  };
}
